import {
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import StyledTableRow from "../../components/StyledTableRow";
import { countOrACVFormatter } from "../../util/customFunctions";
import CopyTablesObject from "../../components/xlsx-export/CopyTablesObject";

const useStyle = makeStyles((theme) => ({
  root: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: "2rem",
  },
  sticky: {
    position: "sticky",
    left: -1,
    background: "white",
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      width: "1.5px",
      background: "lightgrey",
    },
  },
  repHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    width: "150px",
    textAlign: "center",
  },
   repCell: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
  },
  table: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
  },
  mainTableContainer: {
    maxHeight: "85vh",
    maxWidth: "90vw",
    border: "0.5px solid lightgrey",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    // borderRadius: "8px",
  },
}));

export default function PipelineGoalTable(props) {
  const classes = useStyle();
  const tableRef = useRef();
  const tableContainerRef = useRef();

  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [rowPin, setRowPin] = useState(false);

  const uniqueCols = [...props.quarters, 'Total'] || [];


  useEffect(() => {
    const tableContainer = tableContainerRef.current;

    const handleOverflowCheck = () => {
      if (tableContainer) {
        setIsOverflowing(
          tableContainer.scrollWidth > tableContainer.offsetWidth
        );
      }
    };

    handleOverflowCheck();
    window.addEventListener("resize", handleOverflowCheck);

    return () => window.removeEventListener("resize", handleOverflowCheck);
  }, []);

  useEffect(() => {
    const tableContainer = tableContainerRef.current;

    const handleScroll = () => {
      setIsSticky(tableContainer.scrollLeft > 0);
      setRowPin(tableContainer.scrollTop > 0);
    };

    tableContainer.addEventListener("scroll", handleScroll);
    return () => tableContainer.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={classes.root} >
      <Grid container direction="column" alignItems="center">
       
          <div style={{ alignSelf: "flex-end", marginBottom: "10px" }}>
            <CopyTablesObject tableRef={tableRef} />
          </div>
        <TableContainer
          ref={tableContainerRef}
          className={classes.mainTableContainer}
        >
          <Table
            ref={tableRef}
            size="small"
            aria-label="data table"
            style={{ tableLayout: "auto", width: "initial" }}
            data-test={props.dataTest}
          >
            <TableHead style={{ position: "sticky", top: -1, zIndex: 5 }}>
              <TableRow>
                <TableCell
                  align="center"
                  className={
                    isSticky
                      ? `${classes.sticky} ${classes.repHeader}`
                      : classes.repHeader
                  }
                  style={{width: '280px'}}
                >
                  {''}
                </TableCell>

                {uniqueCols.map((col, index) => (
                  <TableCell
                    key={col}
                    align="center"
                    className={classes.repHeader}
                    style={{
                      background: index % 2 === 0 ? "#4471c4" : "#5b9bd5",
                      color: "white",
                    }}
                  >
                    {col}
                  </TableCell>
                ))}

                {uniqueCols.length === 0 && (
                  <TableCell
                    className={classes.repHeader}
                    style={{ width: 400, textAlign: "center" }}
                  >
                    No data available
                  </TableCell>
                )}
              </TableRow>
            </TableHead>

            <TableBody>
             
                <StyledTableRow key={'-adsfghvdzhfih-'}>
                  <TableCell
                   
                    className={
                      isSticky
                        ? `${classes.sticky} ${classes.table} ${classes.repCell}`
                        : `${classes.table} ${classes.repCell}`
                    }
                     align="left"
                  >
                    Quota
                  </TableCell>


                  {uniqueCols.map((col) => {
                    const data = props.data.filter(
                      (f) => f.quarter === col 
                    );
                  let acv = "-";
if (data.length > 0) {
  const value = data[0].Quota;
  if (value != null && value !== "") {
    acv = countOrACVFormatter(value, true);
  }
}

                    return (
                      <TableCell
                        key={`ahsdfdshgfhsghfg}-${col}`}
                        align="right"
                        className={classes.repCell}
                      >
                        {acv}
                      </TableCell>
                    );
                  })}
                </StyledTableRow>


                  <StyledTableRow key={'dfhgvfdgdgv'}>
                  <TableCell
                   
                    className={
                      isSticky
                        ? `${classes.sticky} ${classes.table} ${classes.repCell}`
                        : `${classes.table} ${classes.repCell}`
                    }
                     align="left"
                  >
                    Coverage Ratio Goal
                  </TableCell>


                  {uniqueCols.map((col) => {
                    const data = props.data.filter(
                      (f) => f.quarter === col 
                    );
                  let acv = "-";
if (data.length > 0) {
  const value = data[0].Coverage_Ratio_Goal;
  if (value != null && value !== "") {
    acv = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}).format(value);
  }
}
                    return (
                      <TableCell
                        key={`$23664345-${col}`}
                        align="right"
                        className={classes.repCell}
                      >
                        {acv}
                      </TableCell>
                    );
                  })}
                </StyledTableRow>
           
           
   <StyledTableRow key={'dasfgufgs'}>
                  <TableCell
                   
                    className={
                      isSticky
                        ? `${classes.sticky} ${classes.table} ${classes.repCell}`
                        : `${classes.table} ${classes.repCell}`
                    }
                     align="left"
                     style={{width: '200px'}}
                  >
                    Desired Pipeline Coverage
                  </TableCell>


                  {uniqueCols.map((col) => {
                    const data = props.data.filter(
                      (f) => f.quarter === col 
                    );
                  let acv = "-";
if (data.length > 0) {
  const value = data[0].Desired_Pipeline_Coverage;
  if (value != null && value !== "") {
    acv = countOrACVFormatter(value, true);
  }
}

                    return (
                      <TableCell
                        key={`apmgdd-${col}`}
                        align="right"
                        className={classes.repCell}
                      >
                        {acv}
                      </TableCell>
                    );
                  })}
                </StyledTableRow>
      


    
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </div>
  );
}
